<template>
  <div class="my-slider">
    <v-row class="px-3 mt-n5">
      <v-col cols="12" md="3" v-if="!onMobile">
        <v-subheader class="pl-0">Salary range (0 - 200k):</v-subheader>
        <v-range-slider
          v-model="selectedRange"
          @start="mousedown"
          @end="doAction"
          @mousedown="mousedown"
          @mouseup="mouseup"
          step="10"
          min="0"
          max="200"
          thumb-label
          hide-details
        ></v-range-slider>
      </v-col>
      <v-col cols="12" md="9">
        <v-subheader class="pl-0">
          {{ labelSlider }}
          <div @click="dialogStepSize = true" class="ml-4 mt-1 step-size">
            {{ labelSliderInSteps }}
            <v-icon color="maroon">mdi-arrow-down-drop-circle-outline</v-icon>
          </div>
        </v-subheader>

        <v-slider
          v-model="gross"
          thumb-label
          :max="rangeMax"
          :min="rangeMin"
          :step="stepSize"
          thumb-size="50"
          :value="getAA"
          hide-details
        >
          <template v-slot:thumb-label>
            <span>{{ getAA }}</span>
          </template>
          <template v-slot:prepend>
            <span
              :class="{ sliding: sliding && slidingLeft }"
              class="my-range my-range-left"
            >{{ format(rangeMin) }}</span>
          </template>
          <template v-slot:append>
            <span
              :class="{ sliding: sliding && slidingRight }"
              class="my-range my-range-right"
            >{{ format(rangeMax) }}</span>
          </template>
        </v-slider>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogStepSize" max-width="360">
        <v-card>
          <v-card-title class="headline">Select 'step' size</v-card-title>
          <v-card-text>
            <v-row justify="center">
              <v-btn-toggle v-model="stepSize" mandatory>
                <v-btn class="btn-step" value="1000">£1000</v-btn>
                <v-btn class="btn-step" value="500">£500</v-btn>
                <v-btn class="btn-step" value="100">£100</v-btn>
                <v-btn class="btn-step" value="1">none</v-btn>
              </v-btn-toggle>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { FormatInfo, formatValue2 } from "../utils";
//let fiA = new FormatInfo("yearly", 2, true, false);

export default {
  data: () => ({
    tempMin: 0,
    tempMax: 0,
    sliding: false,
    slidingLeft: false,
    slidingRight: false,
    dialogStepSize: false,
    toggle_exclusive: undefined
  }),
  methods: {
    format(myValue) {
      let xx = myValue / 1000;
      xx = Math.floor(xx);
      if (xx == 0) return "0";
      return "" + xx + "k";
    },
    doAction(arr) {
      console.log("doaction");
      this.mouseup();
      this.$store.dispatch("setSelectedRange", arr);
    },
    mousedown() {
      this.sliding = true;
    },
    mouseup() {
      this.sliding = false;
      this.slidingLeft = false;
      this.slidingRight = false;
    }
  },
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    labelSlider() {
      if (this.onMobile) return "Select gross salary:";
      return "Select gross salary within range:";
    },
    labelSliderInSteps() {
      if (this.onMobile) return "steps: £" + this.stepSize;
      if (this.stepSize == "1") return "steps of 1 pound";
      return "steps of £" + this.stepSize + " pounds";
    },
    rangeMin() {
      if (this.slidingLeft) return this.tempMin * 1000;
      else return this.$store.getters.getRangeMin * 1000;
    },
    rangeMax() {
      if (this.slidingRight) return this.tempMax * 1000;
      else return this.$store.getters.getRangeMax * 1000;
    },
    gross: {
      get() {
        return this.$store.getters.getGrossIncome("", 0, false);
        //return this.$store.getters.getData(fiA, "grossIncome");
      },
      set(newValue) {
        this.$store.dispatch("setGrossIncome", newValue);
      }
    },
    selectedRange: {
      get() {
        return this.$store.getters.selectedRange;
      },
      set(newValue) {
        // just react to values being updated and so...
        this.tempMin = newValue[0];
        this.tempMax = newValue[1];
        if (newValue[0] != this.$store.getters.getRangeMin)
          this.slidingLeft = true;
        if (newValue[1] != this.$store.getters.getRangeMax)
          this.slidingRight = true;
      }
    },
    getAA() {
      let xx = this.$store.getters.getGrossIncome("", 0, false);
      xx = xx / 1000;
      xx = Math.floor(xx);
      return "£ " + xx + " k";
    },
    stepSize: {
      get() {
        return this.$store.getters.stepSize;
      },
      set(newValue) {
        this.$store.dispatch("setStepSize", newValue);
      }
    }
  },
  watch: {
    onMobile(newValue) {
      console.log("onMobile " + newValue);
      if (newValue) {
        this.doAction([0, 200]);
      }
      //this.$store.dispatch("setGrossIncome", newValue);
    }
  }
};
</script>

<style>
.my-range {
  white-space: nowrap;
  background-color: #595d30a8;
  color: #fff700;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid gray;
  margin-top: -1px;
  transition: all 0.3s linear;
}
.my-range-left {
  margin-right: -8px;
}
.my-range-right {
  margin-left: -8px;
}
.my-range.sliding {
  background-color: #fc0202a8;
  color: #fff700;
  transform: scale(1.2);
}
.btn-step {
  width: 80px;
}
.step-size {
  transform: scale(0.75);
  transition: all 0.3s linear;
  font-style: italic;
}
.step-size:hover {
  /* transform: scale(0.9); */
  color: maroon;
  cursor: pointer;
}
</style>